@if (!hidden()) {
  <div class="fab">
    @if (open()) {
      <section class="fab__panel anim-fade-up" aria-label="HNH Jewellery assistant">
        <header class="fab__head">
          <div>
            <h2>HNH Assistant</h2>
            <p>Usually replies instantly</p>
          </div>
          <button type="button" class="fab__close" (click)="toggle()" aria-label="Close chat">&times;</button>
        </header>

        <div class="fab__thread" #thread>
          @for (message of messages(); track $index) {
            <div class="fab__msg" [class.fab__msg--user]="message.role === 'user'" [class.fab__msg--error]="message.error">
              {{ message.content }}
            </div>
          }
          @if (typing()) {
            <div class="fab__msg fab__typing" aria-label="Assistant is typing">
              <span></span><span></span><span></span>
            </div>
          }
        </div>

        <form class="fab__composer" (ngSubmit)="send()">
          <input
            type="text"
            name="message"
            placeholder="Ask about our jewellery…"
            autocomplete="off"
            maxlength="600"
            [ngModel]="draft()"
            (ngModelChange)="draft.set($event)"
            aria-label="Your message"
          />
          <button type="submit" class="fab__send" [disabled]="typing() || !draft().trim()" aria-label="Send message">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 2L11 13"/><path d="M22 2l-7 20-4-9-9-4 20-7z"/></svg>
          </button>
        </form>
      </section>
    }

    <div class="fab__buttons">
      <a class="fab__btn fab__btn--wa" [href]="whatsappLink" target="_blank" rel="noopener" aria-label="Chat on WhatsApp">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><path d="M12 3a9 9 0 00-7.8 13.5L3 21l4.7-1.2A9 9 0 1012 3z"/><path d="M9 9.5c.5 2.5 3 5 5.5 5.5l1.5-1.5-2-1.5-1 .7c-.8-.4-1.8-1.4-2.2-2.2l.7-1L10 7.5 9 9.5z"/></svg>
      </a>
      <button type="button" class="fab__btn fab__btn--chat" (click)="toggle()" [attr.aria-expanded]="open()" aria-label="Toggle assistant chat">
        @if (open()) {
          <span class="fab__btn-x">&times;</span>
        } @else {
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><path d="M21 12a8 8 0 01-8 8H4l2-3a8 8 0 1115-5z"/><circle cx="9" cy="12" r="0.8" fill="currentColor"/><circle cx="13" cy="12" r="0.8" fill="currentColor"/><circle cx="17" cy="12" r="0.8" fill="currentColor"/></svg>
        }
      </button>
    </div>
  </div>
}
